export const ROUTES = {
  LOGIN: '/login',
  SCHEDULE_A_DEMO: '/schedule-a-demo',
  DASHBOARD: '/dashboard',
  HOME: '/',
  UPLOAD_FILES: '/upload-files',
  TEMPLATES: '/upload-files/templates',
  DOCUMENTS: '/documents',
  DOCUMENT_DETAIL: '/documents/:documentId',
  RECORDS: '/records',
  USER_MANAGEMENT: '/user-management',
  USER_GUIDES: '/user-guides',
  FORBIDDEN: '/forbidden',
  SERVER_ERROR: '/server-error',
} as const;

export const ROUTE_LABELS: Record<string, string> = {
  dashboard: 'RECORD-AI Dashboard',
  'upload-files': 'Upload File(s)',
  documents: 'Documents',
  templates: 'Templates',
  records: 'Records',
  'user-management': 'User Management',
  'user-guides': 'User Guides',
  'user-listing': 'User Listing',
  settings: 'Settings',
  profile: 'Profile',
};
